/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  PasswordChangeRequest,
  PasswordChangeRequestV2,
  PasswordCreateRequest,
  PasswordResetRequest
} from '../../model';





export const sendReset = (
    passwordResetRequest: PasswordResetRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/passwordreset/sendreset`,
      passwordResetRequest,options
    );
  }



export const getSendResetMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReset>>, TError,{data: PasswordResetRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof sendReset>>, TError,{data: PasswordResetRequest}, TContext> => {

const mutationKey = ['sendReset'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReset>>, {data: PasswordResetRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendReset(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendResetMutationResult = NonNullable<Awaited<ReturnType<typeof sendReset>>>
    export type SendResetMutationBody = PasswordResetRequest
    export type SendResetMutationError = AxiosError<unknown>

    export const useSendReset = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReset>>, TError,{data: PasswordResetRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendReset>>,
        TError,
        {data: PasswordResetRequest},
        TContext
      > => {

      const mutationOptions = getSendResetMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createPassword = (
    passwordCreateRequest: PasswordCreateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/passwordreset/createpassword`,
      passwordCreateRequest,options
    );
  }



export const getCreatePasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPassword>>, TError,{data: PasswordCreateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createPassword>>, TError,{data: PasswordCreateRequest}, TContext> => {

const mutationKey = ['createPassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPassword>>, {data: PasswordCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof createPassword>>>
    export type CreatePasswordMutationBody = PasswordCreateRequest
    export type CreatePasswordMutationError = AxiosError<unknown>

    export const useCreatePassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPassword>>, TError,{data: PasswordCreateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPassword>>,
        TError,
        {data: PasswordCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreatePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @deprecated
 */
export const changePassword = (
    passwordChangeRequest: PasswordChangeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/passwordreset/changepassword`,
      passwordChangeRequest,options
    );
  }



export const getChangePasswordMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: PasswordChangeRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = PasswordChangeRequest
    export type ChangePasswordMutationError = AxiosError<unknown>

    /**
 * @deprecated
 */
export const useChangePassword = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: PasswordChangeRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: PasswordChangeRequest},
        TContext
      > => {

      const mutationOptions = getChangePasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Change password to newPassword
 * @summary Change password
 */
export const changePasswordV2 = (
    passwordChangeRequestV2: PasswordChangeRequestV2, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/passwordreset/changepasswordV2`,
      passwordChangeRequestV2,options
    );
  }



export const getChangePasswordV2MutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordV2>>, TError,{data: PasswordChangeRequestV2}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof changePasswordV2>>, TError,{data: PasswordChangeRequestV2}, TContext> => {

const mutationKey = ['changePasswordV2'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePasswordV2>>, {data: PasswordChangeRequestV2}> = (props) => {
          const {data} = props ?? {};

          return  changePasswordV2(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordV2MutationResult = NonNullable<Awaited<ReturnType<typeof changePasswordV2>>>
    export type ChangePasswordV2MutationBody = PasswordChangeRequestV2
    export type ChangePasswordV2MutationError = AxiosError<unknown>

    /**
 * @summary Change password
 */
export const useChangePasswordV2 = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordV2>>, TError,{data: PasswordChangeRequestV2}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePasswordV2>>,
        TError,
        {data: PasswordChangeRequestV2},
        TContext
      > => {

      const mutationOptions = getChangePasswordV2MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    